import * as turf from "@turf/area";

export const calculateAcres = (polygon) => {
  if (!polygon || !polygon.coordinates) return 0;
  const feature = { type: "Feature", geometry: polygon };
  const areaInSquareMeters = turf.default(feature);
  const areaInAcres = areaInSquareMeters / 4046.86;
  return Math.round(areaInAcres * 100) / 100;
};

export const calculateTotalAcres = (polygons) => {
  if (!polygons || polygons.length === 0) return 0;
  return polygons.reduce((total, poly) => total + calculateAcres(poly), 0);
};

export const calculateBounds = (polygons) => {
  const allCoords = [];
  polygons.forEach(poly => {
    if (poly && poly.coordinates && poly.coordinates[0]) {
      allCoords.push(...poly.coordinates[0]);
    }
  });
  return allCoords;
};

export const calculateCenter = (polygons) => {
  if (!polygons || polygons.length === 0) return [-78.6382, 35.7796];
  
  const coords = polygons[0].coordinates?.[0];
  if (!coords || coords.length === 0) return [-78.6382, 35.7796];
  
  const lngs = coords.map(c => c[0]);
  const lats = coords.map(c => c[1]);
  return [
    (Math.min(...lngs) + Math.max(...lngs)) / 2,
    (Math.min(...lats) + Math.max(...lats)) / 2
  ];
};
